import React from "react";
import { Alert } from "antd";
// We will need vis-timeline-react later
// import Timeline from 'vis-timeline-react';

const FlightTimelineView = ({ flights, onShowDetails }) => {
    // TODO: Implement vis-timeline logic

    // Placeholder content
    return <Alert message="时间轴视图 (待实现)" description="此处将使用 vis-timeline-react 展示航班时间轴。" type="info" showIcon />;

    /*
    // Basic structure for vis-timeline-react
    const items = flights.map(flight => ({
        id: flight.id,
        content: `${flight.flight_number} (${flight.departure_airport}-${flight.arrival_airport})`,
        start: flight.std,
        end: flight.sta,
        title: `STD: ${dayjs.utc(flight.std).format('HH:mm')} STA: ${dayjs.utc(flight.sta).format('HH:mm')}`,
        group: flight.aircraft_reg || 'Unassigned' // Group by aircraft or another criteria
    }));

    // Configuration options for the timeline
    const options = {
        stack: false,
        // Add other vis-timeline options as needed
        // Example: orientation: { axis: 'top' },
        // Example: zoomMin: 1000 * 60 * 60 * 24, // Minimum zoom level 1 day
    };

     // Prepare groups if grouping by aircraft
     const groups = Array.from(new Set(flights.map(f => f.aircraft_reg).filter(Boolean)))
     .map(reg => ({ id: reg, content: reg }));

    const handleSelect = (properties) => {
        if (properties.items.length > 0) {
            const selectedFlightId = properties.items[0];
            const selectedFlight = flights.find(f => f.id === selectedFlightId);
            if (selectedFlight) {
                onShowDetails(selectedFlight);
            }
        }
    };


    return (
        <div>
            <p>时间轴视图</p>
            {flights.length > 0 ? (
                 <Timeline
                    items={items}
                    options={options}
                    groups={groups} // Pass groups if using them
                    selectHandler={handleSelect} // Handle clicks on items
                 />
            ) : (
                <p>没有可显示的航班数据。</p>
            )}
        </div>
    );
    */
};

export default FlightTimelineView;
